<template lang="pug">
.row
    .col-10
        .collapsable_title {{title}}
    .col-2
        em.fas.collapsable_toggle(
            :class="{'fa-chevron-up':showContent, 'fa-chevron-down':!showContent}"
            @click="input")
    .col-12(v-show="showContent")
        slot
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContent: this.value,
    }
  },
  watch: {
    value() {
      if (this.value !== this.showContent) {
        this.showContent = this.value
      }
    },
  },
  methods: {
    input() {
      this.showContent = !this.showContent
      this.$emit('input', this.showContent)
    },
  },
}
</script>
<style lang="scss" scoped>
.collapsable_title {
  font: normal normal bold 14px/18px Open Sans;
  letter-spacing: 0px;
  color: var(--color-denim);
}
.collapsable_toggle {
  color: var(--color-denim);
  cursor: pointer;
}
</style>
